// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Review_item__GDbG6 {
  background-color: var(--white);
  box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.0509803922);
  border-radius: 12px;
}

.Review_body__uj1tR {
  padding: 8px 12px 12px;
}

.Review_main__ZyBfG {
  display: flex;
  grid-column-gap: 5px;
}

.Review_title__pSAso {
  font-weight: 500;
  line-height: 20px;
  display: flex;
  margin-bottom: 6px;
}

.Review_txt__EMCpz {
  color: #3D4149;
  margin-bottom: 6px;
}

.Review_assignees__1MSEz {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  grid-gap: 4px;
  padding-top: 4px;
}
.Review_assignees--more__6VcbQ {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  grid-gap: 0;
}

.Review_assignee__fKifr {
  display: flex;
  align-items: center;
}

.Review_avatar__gA0o0 {
  margin: 0 8px 0 4px;
}

.Review_avatars__1AuAP {
  flex-shrink: 0;
}

.Review_name__wLR1D {
  color: #54575C;
  word-break: break-word;
  margin-bottom: 3px;
}

.Review_time__rpX9E {
  font-size: 12px;
  line-height: 14px;
  font-weight: normal;
  color: #7A808B;
  flex-shrink: 0;
  padding-top: 3px;
}
@media (min-width: 1200px) {
  .Review_time__rpX9E {
    padding-top: 9px;
  }
}

@media (min-width: 1200px) {
  .Review_timeInHeader__42Fjr {
    align-self: center;
    padding-top: 0;
    margin-left: auto;
  }
}

.Review_btnLink__dIfsS {
  flex-shrink: 0;
  color: #4F4F4F;
  width: 12px;
  height: 12px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
  transition: var(--transition);
  transform: translateY(3px);
}
@media (hover: hover) {
  .Review_btnLink__dIfsS:hover {
    opacity: 0.5;
  }
}

.Review_editBtn__\\+FjBC {
  margin-left: auto;
}

.Review_stars__Cbn10 {
  padding-top: 4px;
  width: auto;
  flex-shrink: 0;
  margin-left: auto;
  margin-right: 6px;
}
@media (min-width: 1200px) {
  .Review_stars__Cbn10 {
    padding-top: 10px;
    margin-right: 0;
  }
}
@media (min-width: 1200px) {
  .Review_stars--is-edit__qEfiU {
    padding-top: 0;
  }
}

.Review_footer__JaGFb {
  display: flex;
  align-items: center;
  grid-column-gap: 8px;
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
  padding: 0 8px 8px;
}
@media (min-width: 1200px) {
  .Review_footer__JaGFb {
    background-color: #FAFAFA;
    padding: 12px;
  }
}
.Review_footer__JaGFb button {
  padding-left: 24px;
  padding-right: 24px;
}
.Review_footer__JaGFb button img {
  right: 6px;
}

.Review_btnCancel__LhBGU {
  margin-right: auto;
}

.Review_bot__giVr3 {
  display: none;
  border-top: 1px solid #F8F7F7;
  padding-top: 8px;
  margin-top: 12px;
}
@media (min-width: 640px) {
  .Review_bot__giVr3 {
    display: block;
  }
}

.Review_label__FarPd {
  font-size: 12px;
  line-height: 14px;
  display: block;
  color: #54575C;
  margin-bottom: 8px;
}

.Review_textarea__A4wps {
  min-height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/components/Review/Review.module.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,uDAAA;EACA,mBAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,mBAAA;AAAF;;AAGA;EACE,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AAAF;AAEE;EARF;IASI,gBAAA;EACF;AACF;;AAGE;EADF;IAEI,kBAAA;IACA,cAAA;IACA,iBAAA;EACF;AACF;;AAEA;EACE,cAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,0BAAA;AACF;AACE;EACE;IACE,YAAA;EACJ;AACF;;AAGA;EACE,iBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAAF;AAEE;EAPF;IAQI,iBAAA;IACA,eAAA;EACF;AACF;AAEI;EADF;IAEI,cAAA;EACJ;AACF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kCAAA;EACA,mCAAA;EACA,kBAAA;AAAF;AAEE;EARF;IASI,yBAAA;IACA,aAAA;EACF;AACF;AACE;EACE,kBAAA;EACA,mBAAA;AACJ;AACI;EACE,UAAA;AACN;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,aAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AADF;AAGE;EANF;IAOI,cAAA;EAAF;AACF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":[".item {\r\n  background-color: var(--white);\r\n  box-shadow: 0px 5px 9px 0px #0000000D;\r\n  border-radius: 12px;\r\n}\r\n\r\n.body {\r\n  padding: 8px 12px 12px;\r\n}\r\n\r\n.main {\r\n  display: flex;\r\n  grid-column-gap: 5px;\r\n}\r\n\r\n.title {\r\n  font-weight: 500;\r\n  line-height: 20px;\r\n  display: flex;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.txt {\r\n  color: #3D4149;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.assignees {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  grid-gap: 4px;\r\n  padding-top: 4px;\r\n\r\n  &--more {\r\n    display: flex;\r\n    align-items: center;\r\n    flex-wrap: nowrap;\r\n    grid-gap: 0;\r\n  }\r\n}\r\n\r\n.assignee {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.avatar {\r\n  margin: 0 8px 0 4px;\r\n}\r\n\r\n.avatars {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.name {\r\n  color: #54575C;\r\n  word-break: break-word;\r\n  margin-bottom: 3px;\r\n}\r\n\r\n.time {\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  font-weight: normal;\r\n  color: #7A808B;\r\n  flex-shrink: 0;\r\n  padding-top: 3px;\r\n\r\n  @media (min-width: 1200px) {\r\n    padding-top: 9px;\r\n  }\r\n}\r\n\r\n.timeInHeader {\r\n  @media (min-width: 1200px) {\r\n    align-self: center;\r\n    padding-top: 0;\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n.btnLink {\r\n  flex-shrink: 0;\r\n  color: #4F4F4F;\r\n  width: 12px;\r\n  height: 12px;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-left: 4px;\r\n  transition: var(--transition);\r\n  transform: translateY(3px);\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      opacity: 0.5;\r\n    }\r\n  }\r\n}\r\n\r\n.editBtn {\r\n  margin-left: auto;\r\n}\r\n\r\n.stars {\r\n  padding-top: 4px;\r\n  width: auto;\r\n  flex-shrink: 0;\r\n  margin-left: auto;\r\n  margin-right: 6px;\r\n\r\n  @media (min-width: 1200px) {\r\n    padding-top: 10px;\r\n    margin-right: 0;\r\n  }\r\n\r\n  &--is-edit {\r\n    @media (min-width: 1200px) {\r\n      padding-top: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  align-items: center;\r\n  grid-column-gap: 8px;\r\n  border-bottom-left-radius: inherit;\r\n  border-bottom-right-radius: inherit;\r\n  padding: 0 8px 8px;\r\n\r\n  @media (min-width: 1200px) {\r\n    background-color: #FAFAFA;\r\n    padding: 12px;\r\n  }\r\n\r\n  button {\r\n    padding-left: 24px;\r\n    padding-right: 24px;\r\n\r\n    img {\r\n      right: 6px;\r\n    }\r\n  }\r\n}\r\n\r\n.btnCancel {\r\n  margin-right: auto;\r\n}\r\n\r\n.bot {\r\n  display: none;\r\n  border-top: 1px solid #F8F7F7;\r\n  padding-top: 8px;\r\n  margin-top: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.label {\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n  display: block;\r\n  color: #54575C;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.textarea {\r\n  min-height: 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Review_item__GDbG6`,
	"body": `Review_body__uj1tR`,
	"main": `Review_main__ZyBfG`,
	"title": `Review_title__pSAso`,
	"txt": `Review_txt__EMCpz`,
	"assignees": `Review_assignees__1MSEz`,
	"assignees--more": `Review_assignees--more__6VcbQ`,
	"assignee": `Review_assignee__fKifr`,
	"avatar": `Review_avatar__gA0o0`,
	"avatars": `Review_avatars__1AuAP`,
	"name": `Review_name__wLR1D`,
	"time": `Review_time__rpX9E`,
	"timeInHeader": `Review_timeInHeader__42Fjr`,
	"btnLink": `Review_btnLink__dIfsS`,
	"editBtn": `Review_editBtn__+FjBC`,
	"stars": `Review_stars__Cbn10`,
	"stars--is-edit": `Review_stars--is-edit__qEfiU`,
	"footer": `Review_footer__JaGFb`,
	"btnCancel": `Review_btnCancel__LhBGU`,
	"bot": `Review_bot__giVr3`,
	"label": `Review_label__FarPd`,
	"textarea": `Review_textarea__A4wps`
};
export default ___CSS_LOADER_EXPORT___;
